import React from 'react';
import CustomSelect from '../../../componentes/shared/CustomSelect';

const ItemsTable = ({ items, onRemoveItem, onItemChange, disabled, unidadOptions = [], igvOptions = [] }) => {
    return (
        <div className="table-responsive">
            <table className="items-table">
                <thead>
                    <tr>
                        <th style={{width: '50px'}}>Item</th>
                        <th>Descripción</th>
                        <th style={{width: '100px'}}>Cant.</th>
                        <th style={{width: '180px'}}>Und.</th>
                        <th style={{width: '180px'}}>IGV</th>
                        <th style={{width: '120px'}}>P. Venta</th>
                        <th style={{width: '100px'}}>Desc.</th>
                        <th style={{width: '50px'}}></th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={item.id}>
                            <td>{(index + 1).toString().padStart(2, '0')}</td>
                            <td>
                                <input 
                                    className="table-input" 
                                    value={item.descripcion}
                                    onChange={(e) => onItemChange(item.id, 'descripcion', e.target.value)}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <input 
                                    type="number" 
                                    className="table-input" 
                                    value={item.cantidad}
                                    onChange={(e) => onItemChange(item.id, 'cantidad', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <CustomSelect 
                                    className="table-input"
                                    options={unidadOptions}
                                    label="nombre"
                                    value="id"
                                    initialValue={item.unidad}
                                    onSelect={(opt) => onItemChange(item.id, 'unidad', opt.id)}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <CustomSelect 
                                    className="table-input"
                                    options={igvOptions}
                                    label="nombre"
                                    value="id"
                                    initialValue={item.igv}
                                    onSelect={(opt) => onItemChange(item.id, 'igv', opt.id)}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <input 
                                    type="number" 
                                    className="table-input" 
                                    value={item.pVenta}
                                    onChange={(e) => onItemChange(item.id, 'pVenta', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <input 
                                    type="number" 
                                    className="table-input" 
                                    value={item.descuento}
                                    onChange={(e) => onItemChange(item.id, 'descuento', e.target.value)}
                                    onFocus={(e) => e.target.select()}
                                    disabled={disabled}
                                />
                            </td>
                            <td>
                                <button className="btn-remove" onClick={() => onRemoveItem(item.id)} disabled={disabled}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ItemsTable;